import { Sprite } from 'pixi.js';
import { IMAGES, MainSignals, TickCallData } from '../../../../settings/constants';
import { SCENE_2 } from '../../../../settings/positions';
import SceneBase from '../base/SceneBase';
import { TweenMax, Power1 } from 'gsap';
import Cloud from './Cloud';

const CLOUD_TEXTURES = [
  '2-cloud-1-3.png',
  '2-cloud-1-2.png',
  '2-cloud-1-1.png',
  '2-cloud-1-2.png',
  '2-cloud-1-1.png',
  '2-cloud-1-0.png',
  '2-cloud-0-5.png',
  '2-cloud-0-4.png',
  '2-cloud-0-3.png',
  '2-cloud-0-4.png',
  '2-cloud-0-3.png',
  '2-cloud-0-1.png',
  '2-cloud-0-2.png',
  '2-cloud-0-1.png',
  '2-cloud-0-0.png',
];
export default class Scene2 extends SceneBase {
  skirt: Sprite;
  clouds: Cloud[] = [];

  animActive = false;

  constructor(signals: MainSignals) {
    super(signals, SCENE_2, 2, 2);

    // parts
    const bg = Sprite.from(IMAGES.BG_2);
    bg.anchor.set(0.5);
    this.addChild(bg);

    this.setClouds();

    this.skirt = Sprite.from('2-char-bottom.png');
    this.skirt.anchor.set(0.76, 0.03);
    this.skirt.x = -120;
    this.skirt.y = -15;
    this.addChild(this.skirt);

    const charTop = Sprite.from('2-char-top.png');
    charTop.anchor.set(0.5);
    this.addChild(charTop);
  }

  // --------------------------------------------------------------
  // Clouds
  // --------------------------------------------------------------

  setClouds(): void {
    const top = -400;
    const step = 250 / (CLOUD_TEXTURES.length - 1);

    this.clouds = CLOUD_TEXTURES.map((textureName, index) => {
      const cloud = new Cloud(textureName, top + step * index);
      this.addChild(cloud);
      return cloud;
    });
  }

  moveClouds(): void {
    this.clouds.forEach((cloud) => {
      cloud.move();
    });
  }

  // --------------------------------------------------------------
  // Skirt
  // --------------------------------------------------------------

  moveSkirtUp(): void {
    TweenMax.to(this.skirt, 0.5 + Math.random() * 0.8, {
      rotation: -0.02 - Math.random() * 0.02,
      ease: Power1.easeInOut,
      onComplete: this.moveSkirtDown.bind(this),
    });
  }

  moveSkirtDown(): void {
    TweenMax.to(this.skirt, 0.5 + Math.random() * 1.2, {
      rotation: Math.random() * 0.02,
      ease: Power1.easeInOut,
      onComplete: this.moveSkirtUp.bind(this),
    });
  }

  activateAnimation(value: boolean): void {
    if (this.animActive !== value) {
      this.animActive = value;
      if (this.animActive) {
        this.moveSkirtUp();
      } else {
        TweenMax.killTweensOf(this.skirt);
      }
    }
  }

  // --------------------------------------------------------------
  // State switching
  // --------------------------------------------------------------

  tickCall(data: TickCallData): void {
    super.tickCall(data);

    // check state
    this.activateAnimation(data.scroll > this.show && data.scroll < this.hideStart);

    // clouds
    if (this.animActive) {
      this.moveClouds();
    }
  }
}
